import { tint } from 'polished'
import styled from 'styled-components'

export const ImporterErrorListStyled = styled.div`
  text-align: left;
  max-height: ${(props) => props.theme.typography.pxToRem(360)};
  margin: 0 auto;
  overflow: auto;
  border: 1px solid ${(props) => props.theme.colors.content.border};

  .row-checked {
    color: ${(props) => props.theme.colors.disabled};
  }

  .error-group-child-row {
    background-color: ${(props) => tint(0.8, props.theme.colors.lightGrey)};
  }

  .group-toggle-icon {
    cursor: pointer;
    position: relative;
    display: block;
    font-size: ${(props) => props.theme.typography.pxToRem(14)};
    text-align: center;
    color: ${(props) => props.theme.colors.text.primary};
  }
`
